import { render } from "./formOptionsTable.vue?vue&type=template&id=2f2ff88b"
import script from "./formOptionsTable.vue?vue&type=script&lang=js"
export * from "./formOptionsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__